module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921052649_T.b967b48d.jpg";